import React from "react"

import { Wrapper } from "./Button.styles"

const Button = ({ type, text, callback }) => (
  <Wrapper type={type} onClick={callback}>
    {text}
  </Wrapper>
)

export default Button
